var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28467 3.77702C2.87076 3.77702 2.52897 4.11881 2.52897 4.53271V13.6011C2.52897 14.015 2.87076 14.3568 3.28467 14.3568H15.3758C15.7897 14.3568 16.1315 14.015 16.1315 13.6011V4.53271C16.1315 4.11881 15.7897 3.77702 15.3758 3.77702H3.28467ZM1.01758 4.53271C1.01758 3.28409 2.03604 2.26562 3.28467 2.26562H15.3758C16.6244 2.26562 17.6429 3.28409 17.6429 4.53271V13.6011C17.6429 14.8497 16.6244 15.8682 15.3758 15.8682H3.28467C2.03604 15.8682 1.01758 14.8497 1.01758 13.6011V4.53271Z",
    fill: "#23235F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15425 4.09974C1.39359 3.75783 1.86479 3.67467 2.2067 3.91401L9.33031 8.90054L16.4539 3.91401C16.7958 3.67467 17.267 3.75783 17.5064 4.09974C17.7457 4.44166 17.6625 4.91286 17.3206 5.1522L9.76367 10.4421C9.50347 10.6242 9.15714 10.6242 8.89694 10.4421L1.33998 5.1522C0.998062 4.91286 0.914909 4.44166 1.15425 4.09974Z",
    fill: "#23235F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReport);
export default __webpack_public_path__ + "static/media/EmailReport.4ae1d9cc8caad8027f7f1422f92743fc.svg";
export { ForwardRef as ReactComponent };